import { Component, DestroyRef, OnDestroy, OnInit, ViewChild, inject, isDevMode, ChangeDetectionStrategy } from '@angular/core';
import { DatePipe } from '@angular/common';
import { SelectionModel } from '@angular/cdk/collections';
// Services
import { ProductsService } from 'src/app/services/products.service';
import { BatchesService } from 'src/app/services/batches.services';
import { BatchResult } from 'src/app/models/batches/batch-result';
import { ProductListResult } from 'src/app/models/products/product-result';
import { IMasterSuite } from 'src/app/models/mastersuites/mastersuite';
// Models
import {
  EProgressState,
  IPreDefinedFilter,
  IProduct,
  IProductStates,
} from 'src/app/models/products/product';
// Material Modules
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { TableSortService } from 'src/app/services/table-sort.service';
import { TableId } from 'src/app/constants/table.constant';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { MasterSuitesService } from 'src/app/services/mastersuites.service';
import { IBatch } from 'src/app/models/batches/batch';
import { Subject, takeUntil } from 'rxjs';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { cloneDeep } from 'lodash';
import { AuthService } from 'src/app/services/auth.service';
import { Permission } from 'src/app/constants/permission.constant';
import { IMAGERY_VIEW, POST_VIEW, CLIENT_VIEW, ViewConfig } from './product-list.view';
import { IPreference, IUserProfile } from 'src/app/models/users/userProfile';
import { SignalrService } from 'src/app/services/signalr.service';
import { SignalrGroup } from 'src/app/services/signalr-group';
import { SignalRIdGroups } from 'src/app/constants/signalr.constant';
import { ClipboardService } from 'src/app/services/clipboard.service';
import { UrlService } from 'src/app/services/url.service';
//------------------------------------------------------------------------
// New Product Manage (List) Main Component
//------------------------------------------------------------------------
@Component({
  selector: 'app-manage-products',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class ProductListComponent implements OnInit, OnDestroy {
  Permission = Permission;
  private readonly destroyRef = inject(DestroyRef);

  get viewConfig(): ViewConfig {
    if (this.authService.hasPermission(Permission.ProductsWorkflowFilter)) {
      return IMAGERY_VIEW;
    }
    if (this.authService.hasPermission(Permission.ShootAssetsRead)) {
      return POST_VIEW;
    }
    return CLIENT_VIEW;
  }

  public pageLink = '';
  currentOrganizationId = '';
  // Service Constructor
  constructor(
    private batchesService: BatchesService,
    public clipboardService: ClipboardService,
    private productsService: ProductsService,
    private mastersuiteService: MasterSuitesService,
    public breakpointObserver: BreakpointObserver,
    public datepipe: DatePipe,
    public dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    public authService: AuthService,
    private signalrService: SignalrService,
    public urlService: UrlService,
    private tableSortService: TableSortService,
  ) {}
  private destroy$ = new Subject();
  view = 'list';
  colPerScreen = 5;
  readonly breakpoint$ = this.breakpointObserver.observe([
    Breakpoints.XLarge,
    Breakpoints.Large,
    Breakpoints.Medium,
    Breakpoints.Small,
  ]);
  girdList: IProduct[] = [];
  user!: IUserProfile | null;
  // MMAPT Jobs table columns and database variable assignment

  dataSource = new MatTableDataSource<IProduct>();
  selection = new SelectionModel<IProduct>(true, []);
  batch!: IBatch;
  productsSubscription: any;
  masterSuiteSubscription: any;
  products: IProduct[] = [];
  serverErrorMessage: String = '';
  errorMessages: string[] = [];
  loaded: boolean = false;
  currentConfigDate!: IPreference;
  searchForm: FormControl<any> = new FormControl();
  // Filters
  public progressState = EProgressState;
  filter: IProductStates = {
    receivalState: [],
    masterSuiteState: [],
    ingestionState: [],
    productionState: [],
    productionReviewState: [],
    enhancementState: [],
    reviewState: [],
    outputsState: [],
    dispatchState: [],
  };
  readonly preDefinedFilters: IPreDefinedFilter[] = [
    {
      key: 'PendingStillsProduction',
      value: 'Pending Stills ',
      icon: 'camera_alt',
      results: [],
    },
    {
      key: 'PendingVideoProduction',
      value: 'Pending Videos ',
      icon: 'camera_alt',
      results: [],
    },
    {
      key: 'PendingApprovalsProduction',
      value: 'Pending Approvals',
      icon: 'camera_alt',
      results: [],
    },
    {
      key: 'PendingStillsEnhancement',
      value: 'Pending Stills ',
      icon: 'auto_awesome',
      results: [],
    },
    {
      key: 'PendingVideoEnhancement',
      value: 'Pending Videos ',
      icon: 'auto_awesome',
      results: [],
    },
    {
      key: 'PendingApprovalsExternalStillsEnhancement',
      value: 'Pending Stills ',
      icon: 'reviews',
      results: [],
    },
    {
      key: 'PendingApprovalsExternalVideosEnhancement',
      value: 'Pending Videos ',
      icon: 'reviews',
      results: [],
    },
  ];
  selectedfilter!: any;

  displayedColumns: string[] = ['Select', 'barcode', 'reference', 'description', 'Actions'];

  masterSuites: IMasterSuite[] = [];

  ngOnInit(): void {
    this.authService.currentPreference.subscribe((res) => {
      this.currentConfigDate = res;
    });
    this.user = this.authService.getAuthInformation();
    this.displayedColumns = Object.keys(this.viewConfig);
    this.breakpoint$.pipe(takeUntil(this.destroy$)).subscribe((value) => {
      this.breakpointChanged();
    });
    if (!this.batch) {
      this.getBatchDetail();
    } else {
      this.initialData();
    }
    this.selection.changed.subscribe((change) => {
      change.added.forEach((product) => {
        this.currentOrganizationId = product.organizationId || '';
      });
    });

    if (
      this.productsService.latestProductsList.batchId == this.route.snapshot.paramMap.get('batchId')
    ) {
      this.dataSource.filter = this.productsService.latestProductsList.search;
      this.searchForm.setValue(this.productsService.latestProductsList.search);
      this.pageIndex = this.productsService.latestProductsList.pageIndex;
      this.pageSize = this.productsService.latestProductsList.pageSize;
    } else {
      this.pageSize = this.currentConfigDate.pageSize!;
      this.productsService.latestProductsList = {
        batchId: '',
        search: '',
        pageIndex: 0,
        pageSize: this.currentConfigDate.pageSize,
        filter: this.filter,
      };
    }
  }

  getBatchDetail() {
    const batchId = this.route.snapshot.paramMap.get('batchId');
    this.batch = this.batchesService.getCurrentBatch();
    if (this.batch == null || batchId != this.batch.id) {
      this.batchesService
        .detailsBatch(batchId!)
        .pipe(takeUntil(this.destroy$))
        .subscribe((result: BatchResult) => {
          this.batch = result.batch;
          this.batchesService.setCurrentBatch(result.batch);
          this.initialData();
        });
    } else {
      this.initialData();
    }
  }

  onFilterPredicate = (data: any, filter: string) => {
    const accumulator = (currentTerm: string, key: string) => {
      return this.nestedFilterCheck(currentTerm, data, key);
    };
    const dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
    const transformedFilter = filter.trim().toLowerCase();
    return dataStr.indexOf(transformedFilter) !== -1;
  };

  // Init, gets current job name, then products associated with that job
  initialData(): void {
    if (this.batch != undefined) {
      //Get products for job
      this.productsSubscription = this.productsService.listProducts(this.batch.id).subscribe(
        (result: ProductListResult) => {
          if (result.products) {
            this.products = this.getProductStates(result.products);
            this.dataSource = new MatTableDataSource<IProduct>(this.products);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            this.tableSortService.applySortToMatSort(this.sort, TableId.PRODUCT_LIST);
            this.dataSource.filterPredicate = this.onFilterPredicate;
            if (
              this.productsService.latestProductsList.batchId ==
              this.route.snapshot.paramMap.get('batchId')
            ) {
              this.dataSource.filter = this.productsService.latestProductsList.search;
              this.filter = this.productsService.latestProductsList.filter;
              this.filterProducts();
              if (this.productsService.latestProductsList.preDefinedFilter != undefined) {
                this.onPreDefinedFilterChange(
                  this.productsService.latestProductsList.preDefinedFilter,
                );
              }
            }
            this.pageLink = this.updatePageLink();
            this.onViewChanged();
          }
        },
        (error: any) => {
          this.serverErrorMessage =
            'There was an error loading the Products from the server. Please restart the system and try again';
          console.error('[ProductListComponent] error', error.message);
        },
      );
      // Get mastersuites for org;
      if (this.authService.hasPermission(Permission.MasterSuitesRead)) {
        this.masterSuiteSubscription = this.mastersuiteService
          .listMasterSuites(this.batch.organizationId)
          .subscribe(
            (mastersuites: any) => {
              if (mastersuites) {
                this.masterSuites = mastersuites;
              }
            },
            (error: any) => {
              this.serverErrorMessage =
                'There was an error loading the Mastersuites from the server. Please restart the system and try again';
              console.error('[ProductListComponent] error', error.message);
            },
          );

        this.loaded = true;
      } else {
        this.loaded = true;
      }

      if (this.authService.hasPermission(Permission.ProductsRead)) {
        SignalrGroup.joinWithId({
          signalrService: this.signalrService,
          destroyRef: this.destroyRef,
          group: SignalRIdGroups.ProductsList,
          id: this.batch.id!,
          data$: this.signalrService.productsData,
          onData: (data: any) => {
            if (data.id) {
              var index = this.products.findIndex((p) => p.id == data.id);
              var selected = this.selection.selected.find((p) => p.id == data.id);
              console.log(index);
              if (index >= 0) {
                var p = this.getProductStates([data])[0];
                this.products[index] = p;
                var dataSourceIndex = this.dataSource.data.findIndex((p) => p.id == data.id);
                this.dataSource.data[dataSourceIndex] = p;
                if (selected != null || undefined) {
                  this.selection.toggle(selected!);
                  this.selection.toggle(this.products[index]);
                }
              } else {
                this.products = [...this.products, this.getProductStates([data])[0]];
                this.dataSource.data = [...this.dataSource.data, this.getProductStates([data])[0]];
              }
            }
          },
        });

        SignalrGroup.joinWithId({
          signalrService: this.signalrService,
          destroyRef: this.destroyRef,
          group: SignalRIdGroups.BatchDetails,
          id: this.batch.id!,
          data$: this.signalrService.batchesData,
          onData: (data: any) => {
            if (data.id) {
              this.batch = data;
            }
          },
        });
      }
    }
  }

  getProductStates(products: IProduct[]) {
    return products.map((p: IProduct) => {
      p.states = {
        receivalState:
          p.receivedPoorCount > 0
            ? [EProgressState.ERROR]
            : p.receivedOkayCount > 0
            ? [EProgressState.ACTIVE]
            : p.receivedGoodCount > 0
            ? [EProgressState.COMPLETE]
            : [EProgressState.PENDING],
        masterSuiteState:
          p.masterSuiteId != null && p.settingsVariantId != null
            ? [EProgressState.COMPLETE]
            : p.masterSuiteId != null && p.settingsVariantId == null
            ? [EProgressState.ACTIVE]
            : [EProgressState.PENDING],
        ingestionState:
          p.ingestedTouchCount == p.expectedTouchCount && p.expectedTouchCount != 0
            ? [EProgressState.COMPLETE]
            : p.ingestedTouchCount > 0
            ? [EProgressState.ACTIVE]
            : [EProgressState.PENDING],
        productionState:
          p.shotTouchCount == p.expectedTouchCount && p.expectedTouchCount != 0
            ? [EProgressState.COMPLETE]
            : p.shotTouchCount > 0
            ? [EProgressState.ACTIVE]
            : [EProgressState.PENDING],
        productionReviewState:
          p.approvedShootAssetCount == p.expectedShootAssetCount && p.expectedShootAssetCount != 0
            ? [EProgressState.COMPLETE]
            : p.rejectedShootAssetCount > 0
            ? [EProgressState.ERROR]
            : p.approvedShootAssetCount > 0
            ? [EProgressState.ACTIVE]
            : [EProgressState.PENDING],
        enhancementState:
          p.postAssetCount == p.expectedPostAssetCount &&
          p.expectedPostAssetCount > 0 &&
          p.internallyRejectedPostAssetCount == 0
            ? [EProgressState.COMPLETE]
            : p.postAssetCount > 0 && p.internallyRejectedPostAssetCount == 0
            ? [EProgressState.ACTIVE]
            : p.internallyRejectedPostAssetCount > 0
            ? [EProgressState.ERROR]
            : [EProgressState.PENDING],
        reviewState:
          p.approvedPostAssetCount == p.expectedPostAssetCount && p.expectedPostAssetCount > 0
            ? [EProgressState.COMPLETE]
            : p.rejectedPostAssetCount > 0
            ? [EProgressState.ERROR]
            : p.approvedPostAssetCount > 0
            ? [EProgressState.ACTIVE]
            : [EProgressState.PENDING],
        outputsState:
          p.releasedInCollection && !p.outdatedRelease
            ? [EProgressState.COMPLETE]
            : p.approvedOutputAssetCount == p.expectedOutputAssetCount &&
              p.expectedOutputAssetCount > 0 &&
              !p.releasedInCollection
            ? [EProgressState.INFO]
            : p.rejectedOutputAssetCount > 0
            ? [EProgressState.ERROR]
            : (p.approvedOutputAssetCount > 0 && p.expectedOutputAssetCount > 0) ||
              p.outdatedRelease
            ? [EProgressState.ACTIVE]
            : [EProgressState.PENDING],
        dispatchState: p.dispatchedCount > 0 ? [EProgressState.COMPLETE] : [EProgressState.PENDING],
      };
      return { ...p, loadedImage: false };
    });
  }

  // MMAPT jobs table variables, for sorting and paginator
  paginator!: MatPaginator;
  sort!: MatSort;
  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.tableSortService.applySortToMatSort(this.sort, TableId.PRODUCT_LIST);
  }

  onSortChange(sort: Sort): void {
    this.tableSortService.setSortState(TableId.PRODUCT_LIST, sort);
  }

  // Applys search filter to the table
  public applyFilter(event: Event) {
    let filterValue = (event.target as HTMLInputElement).value;
    this.productsService.latestProductsList.batchId = this.batch.id;
    this.productsService.latestProductsList.search = filterValue;
    filterValue = filterValue.trim().toUpperCase();

    this.dataSource.filter = filterValue.trim().toUpperCase();
    this.girdList = cloneDeep(
      this.dataSource.data
        .filter((item: any) => {
          const flag = Object.keys(item).some(
            (prop: string) =>
              item[prop] &&
              typeof item[prop] === 'string' &&
              item[prop].toUpperCase().includes(filterValue),
          );
          return flag;
        })
        .sort((a, b) => ((b.barcode ?? '') > (a.barcode ?? '') ? 1 : -1)),
    );
  }

  public applyStaticFilter(key: string) {
    this.dataSource.filter = key.trim().toUpperCase();
  }

  public nestedFilterCheck(search: string, data: any, key: string) {
    if (typeof data[key] === 'object') {
      for (const k in data[key]) {
        if (data[key][k] !== null) {
          search = this.nestedFilterCheck(search, data[key], k);
        }
      }
    } else {
      search += data[key];
    }
    return search;
  }

  allEmpty(obj: { [x: string]: any }): boolean {
    return Object.keys(obj).every((k) => obj[k].length == 0);
  }

  pageIndex: number = 0;
  pageSize: number = 0;
  pageNumberChange(event: any) {
    this.productsService.latestProductsList.batchId = this.batch.id;
    this.productsService.latestProductsList.pageIndex = event.pageIndex;
    this.productsService.latestProductsList.pageSize = event.pageSize;

    if (event.pageSize != this.currentConfigDate.pageSize) {
      this.currentConfigDate.pageSize = event.pageSize;
      let payload = {
        name: this.user?.name,
        preference: this.currentConfigDate,
      };
      this.authService.updatePreference(payload).subscribe((res) => {
        if (isDevMode()) {
          console.log('[DEV] [ProductListComponent] res', res);
        }
      });
    }
  }
  setAll(obj: { [x: string]: any }, val: any) {
    Object.keys(obj).forEach((k) => (obj[k] = val));
  }

  clearFilters() {
    this.setAll(this.filter, []);
    this.filterProducts();
  }

  filterProductsEvent(event: IProductStates) {
    this.filter = event;
    this.filterProducts();
  }

  filterProducts() {
    if (isDevMode()) {
      console.log('[DEV] [ProductListComponent] this', this.filter);
    }
    this.productsService.latestProductsList.batchId = this.batch.id;
    this.productsService.latestProductsList.filter = this.filter;
    this.girdList = cloneDeep(
      (this.dataSource.data = this.products
        .filter((item: IProduct) => {
          var checks = [];
          if (this.filter.receivalState.length > 0) {
            checks.push(this.filter.receivalState.includes(item.states!.receivalState[0]));
          }
          if (this.filter.masterSuiteState.length > 0) {
            checks.push(this.filter.masterSuiteState.includes(item.states!.masterSuiteState[0]));
          }
          if (this.filter.ingestionState.length > 0) {
            checks.push(this.filter.ingestionState.includes(item.states!.ingestionState[0]));
          }
          if (this.filter.productionState.length > 0) {
            checks.push(this.filter.productionState.includes(item.states!.productionState[0]));
          }
          if (this.filter.productionReviewState.length > 0) {
            checks.push(
              this.filter.productionReviewState.includes(item.states!.productionReviewState[0]),
            );
          }
          if (this.filter.enhancementState.length > 0) {
            checks.push(this.filter.enhancementState.includes(item.states!.enhancementState[0]));
          }
          if (this.filter.reviewState.length > 0) {
            checks.push(this.filter.reviewState.includes(item.states!.reviewState[0]));
          }
          if (this.filter.outputsState.length > 0) {
            checks.push(this.filter.outputsState.includes(item.states!.outputsState[0]));
          }

          if (this.filter.dispatchState.length > 0) {
            checks.push(this.filter.dispatchState.includes(item.states!.dispatchState[0]));
          }
          return checks.every((x) => x == true);
        })
        .sort((a, b) => ((b.barcode ?? '') > (a.barcode ?? '') ? 1 : -1))),
    );
  }

  onPreDefinedFilterChange(key: any) {
    this.productsService.latestProductsList.batchId = this.batch.id;
    this.productsService.latestProductsList.preDefinedFilter = key;
    this.selectedfilter = key;
    this.setAll(this.filter, []);
    if (this.selectedfilter != undefined) {
      let item = this.preDefinedFilters.find((x) => x.key == key);
      this.preDefinedFilters.splice(this.preDefinedFilters.indexOf(item!), 1);
      this.preDefinedFilters.unshift(item!);
      this.productsSubscription = this.productsService
        .searchByCode(
          undefined,
          1,
          this.products.length,
          undefined,
          undefined,
          this.selectedfilter,
          this.batch.id!,
        )
        .subscribe((value) => {
          item!.results = value.results;
          this.girdList = cloneDeep(
            (this.dataSource.data = this.products.filter(
              (o1) => !value.results.every((o2) => o1.id != o2.id),
            )),
          );
        });
    } else {
      this.girdList = cloneDeep((this.dataSource.data = this.products));
    }
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
    } else {
      this.dataSource.filteredData.forEach((row) => this.selection.select(row));
    }
  }
  masterToggleGridList() {
    if (this.selection.selected.length >= this.girdList.length) {
      this.selection.clear();
    } else {
      this.girdList.forEach((row) => this.selection.select(row));
    }
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.filteredData.length;
    return numSelected >= numRows;
  }

  selectRow($event: any, row: IProduct) {
    if ($event.srcElement!.nodeName.toLowerCase() == 'td') {
      this.selection.toggle(row);
    }
  }

  onProductUpdated(result: IProduct, product: IProduct) {
    product.barcode = result.barcode;
    product.reference = result.reference;
    product.description = result.description;
    product.productLink = result.productLink;
  }

  getListProduct() {
    this.productsService
      .listProducts(this.batch.id)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (result: ProductListResult) => {
          if (result.products) {
            this.products = this.getProductStates(result.products);
            this.dataSource.data = this.products;
            this.selection.clear();
          }
        },
        (error: any) => {
          this.serverErrorMessage =
            'There was an error loading the Products from the server. Please restart the system and try again';
          console.error('[ProductListComponent] error', error.message);
        },
      );
  }

  onViewChanged() {
    if (this.view === 'grid') {
      this.girdList = cloneDeep(this.dataSource.filteredData);
      this.girdList = this.girdList.sort((a, b) => ((b.barcode ?? '') > (a.barcode ?? '') ? 1 : -1));
    }
    this.selection.clear();
  }

  breakpointChanged() {
    switch (true) {
      case this.breakpointObserver.isMatched(Breakpoints.XLarge):
        this.colPerScreen = 5;
        break;

      case this.breakpointObserver.isMatched(Breakpoints.Large):
        this.colPerScreen = 4;
        break;

      case this.breakpointObserver.isMatched(Breakpoints.Medium):
        this.colPerScreen = 3;
        break;

      case this.breakpointObserver.isMatched(Breakpoints.Small):
        this.colPerScreen = 2;
        break;

      default:
        this.colPerScreen = 1;
        break;
    }
  }

  getLinkImage(image: string, product: IProduct) {
    if (!this.authService.hasPermission(Permission.ShootAssetsRead) && !product.releasedInCollection) {
      return 'assets/image-placeholder.jpg';
    }
    return ProductsService.getLinkImage(image);
  }

  updatePageLink() {
    const identifier: string = this.batch.name;
    const pageLink = `${identifier}`;

    return pageLink;
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
    this.signalrService.clearProducts();
    this.signalrService.clearBatches();
  }
}
